// extracted by mini-css-extract-plugin
export var container = "_i5-0";
export var content = "_i5-3";
export var customerTitle = "_i5-4";
export var empty = "_i5-5";
export var gray = "_i5-6";
export var header = "_i5-7";
export var info = "_i5-8";
export var loading = "_i5-2";
export var loadingCard = "_i5-9";
export var oneLine = "_i5-a";
export var personName = "_i5-e";
export var pillContainer = "_i5-b";
export var selected = "_i5-1";
export var text = "_i5-c";
export var twoLines = "_i5-d";
export var unread = "_i5-f";
export var unreadIndicator = "_i5-g";